import CloneError from "./CloneError.mjs";
/**
 * @public
 */
class DeepCloneError extends CloneError {}
export default DeepCloneError;